import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    class: "has-text-link",
    style: { "text-shadow": "0 0 10px white, 0 0 20px white" }
};
import { loading_success } from "@/lib/helpers";
import { Pitch } from "@/lib/rects/pitch";
import { PublicStore } from "@/lib/store/public";
import { ref } from "vue";
import SVGRect from "../rects/SVGRect.vue";
import ThouCanvas from "../rects/ThouCanvas.vue";
import CampBackground from "./CampBackground.vue";
import ClaimModal from "./ClaimModal.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PitchClaimer',
    setup(__props) {
        const store = PublicStore();
        const picked_pitch = ref(null);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (picked_pitch.value !== null)
                    ? (_openBlock(), _createBlock(ClaimModal, {
                        key: 0,
                        pitch: picked_pitch.value,
                        onClose: _cache[0] || (_cache[0] = ($event) => (picked_pitch.value = null))
                    }, null, 8, ["pitch"]))
                    : _createCommentVNode("", true),
                _createVNode(CampBackground, null, {
                    default: _withCtx(() => [
                        (_unref(loading_success)(_unref(store).selected_event))
                            ? (_openBlock(), _createBlock(ThouCanvas, { key: 0 }, {
                                default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).selected_event.pitches, (pitch) => {
                                        return (_openBlock(), _createBlock(SVGRect, {
                                            key: pitch.id,
                                            variant: pitch.state === 'FREE' ? 'success' : 'danger',
                                            rectangle: _unref(Pitch).load(pitch).position,
                                            title: pitch.state === 'FREE'
                                                ? `Platz '${pitch.name}' jetzt buchen`
                                                : 'belegt',
                                            style: { "cursor": "pointer" },
                                            onClick: _withModifiers(($event) => {
                                                if (pitch.state === 'FREE') {
                                                    picked_pitch.value = pitch;
                                                }
                                            }, ["stop"])
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_1, _toDisplayString(pitch.name), 1)
                                            ]),
                                            _: 2
                                        }, 1032, ["variant", "rectangle", "title", "onClick"]));
                                    }), 128))
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
